/*
  Keret-független munkamenet-tár (a React-en kívül él, hogy az api.ts is elérje).
  P0: localStorage. Későbbi biztonságosabb opció: memória + httpOnly refresh-cookie
  (azonos-origin hoszting mellett kényelmes) — lásd terv "nyitott apró döntések".
*/
export interface StoredSession {
  token: string;
  expiresAtUtc: string;
  refreshToken?: string | null;
  userId: string;
  fullName: string;
  userName: string;
  isAdmin?: boolean;
}

const KEY = "tj.session";
const listeners = new Set<() => void>();

function load(): StoredSession | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as StoredSession) : null;
  } catch {
    return null;
  }
}

let current: StoredSession | null = load();

export function getSession(): StoredSession | null {
  return current;
}

export function getToken(): string | null {
  return current?.token ?? null;
}

export function setSession(next: StoredSession | null): void {
  current = next;
  try {
    if (next) localStorage.setItem(KEY, JSON.stringify(next));
    else localStorage.removeItem(KEY);
  } catch {
    /* privát mód / kvóta — a memóriabeli állapot úgyis érvényes */
  }
  listeners.forEach((l) => l());
}

export function clearSession(): void {
  setSession(null);
}

/** React külső store feliratkozás (useSyncExternalStore-hoz). */
export function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
